import styled from "styled-components";
// Components
import ProjectVersion from "../../projectVersion";
// Assets
import Logo from "../../../assets/icons/logo_eodyne.svg";

const LogoEodyneContainer = styled.div`
  margin: auto;
  width: 132px;
  height: 75px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;
const ShowProjectVersion = styled.div`
  display: none;
  @media (max-width: 690px) {
    display: flex;
  }
`;

const EodyneLogo = () => (
  <LogoEodyneContainer>
    <img src={Logo} alt="logo-eodyne" />
    <ShowProjectVersion>
      <ProjectVersion />
    </ShowProjectVersion>
  </LogoEodyneContainer>
);

export default EodyneLogo;
